<template>
    <div>
        <div class="row" style="margin: 20px 0">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <h1 class="text-primary">Ügyfelek kezelése</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-3">
                <div class="row">
                    <div class="col-lg-6">
                        <button type="submit" class="btn btn-block btn-sm btn-primary" @click="navigate('NewClient')">
                            Új ügyfél
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button type="submit" class="btn btn-block btn-sm btn-primary" @click="$router.back()">
                            Vissza
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="row justify-content-end">
                    <div class="col-lg-5">
                        <div class="form-group" stlye="inline-block">
                            <label class="sr-only" for="filter">Szűrő</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-search"></i>
                                    </div>
                                </div>
                                <input
                                    id="filter"
                                    type="filter"
                                    class="form-control form-control-sm"
                                    placeholder="Szűrő"
                                    v-model="filter"
                                    @keypress.enter="getClientList"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <button type="submit" @click="getClientList" class="btn btn-block btn-sm btn-primary">
                            Szűrés
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <table class="table table-striped table-sm table-hover">
                    <thead class="bg-primary text-white">
                    <tr>
                        <th scope="col"  @click="odOrder('id')">
                            ID
                            <span v-if="renderOrderMarker('id') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('id') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"  @click="odOrder('name')">
                            Név
                            <span v-if="renderOrderMarker('name') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('name') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"  @click="odOrder('email')">
                            E-mail cím
                            <span v-if="renderOrderMarker('email') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('email') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"  @click="odOrder('address')">
                            Cím
                            <span v-if="renderOrderMarker('address') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('address') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"  @click="odOrder('phone')">
                            Telefonszám
                            <span v-if="renderOrderMarker('phone') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('phone') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"  @click="odOrder('comment')">
                            Megjegyzés
                            <span v-if="renderOrderMarker('comment') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('comment') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="client in clients">
                        <th scope="row">{{client.id}}</th>
                        <td>{{client.name}}</td>
                        <td>{{client.email}}</td>
                        <td>{{client.address}}</td>
                        <td>{{client.phone}}</td>
                        <td>{{client.comment}}</td>
                        <td>
                            <button type="submit" class="btn btn-sm btn-primary" @click="navigate('EditClient', {id: client.id})">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="row" v-if="clients.length == 0">
                    <div class="col-lg-12 text-center h5">
                        Nincs megjeleníthető ügyfél.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'clients',
        data() {
            return {
                filter: '',
                clients: [],
                order: {
                    column: 'id',
                    direction: 'DESC'
                }
            }
        },
        methods: {
            getClientList(){
                this.$store.dispatch('ClientModul/getClientList', {
                    filter: this.filter,
                    order: this.order,
                    result: (res)=> {
                        this.clients = res.data.clientList;
                    }
                });
            },
            navigate(name, params = null){
                this.$router.push({
                    name,
                    params
                });
            },
            odOrder(column){
                if(column !== this.order.column){
                    this.order.column = column;
                    this.order.direction = 'ASC';
                } else {
                    switch(this.order.direction){
                        case 'ASC':
                            this.order.direction = 'DESC';
                            break;
                        case 'DESC':
                            this.order = {
                                column: null,
                                direction: null
                            }
                    }
                }

                this.getClientList();
            },
            renderOrderMarker(column){
                if(column === this.order.column){
                    return this.order.direction;
                }
            }
        },
        mounted(){
            this.getClientList();
        }
    }
</script>

<style scoped>
    th{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Clients.vue